<template>
  <div id="ManualSet">
    <template v-if="$route.name == 'viewExamcode'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"

        @search="search"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import {
  getCurrentSelectPlace,
  getPlanAllSessionByPlan,
  getPlanPlaceSessionClassFn,
  exportExamOrderexcel
} from "@/http/modules/examSet/planClass";
export default {
  data() { 
    return {
      selectList: [
          {
            title: "考试批次",
            type: "select",
            requestKey: "planId",
            label: "name",
            value: "id",
            data: [],
          },
          {
            title: "考点",
            type: "select",
            isSearch: true,
            requestKey: "placeId",
            label: "name",
            value: "id",
            data: [{ id: "", name: "全部" }],
          },
          {
            title: "考试场次",
            type: "select",
            requestKey: "sessionId",
            label: "name",
            value: "id",
            data: [{ id: "", name: "全部" }],
          },
        ],
      tableData: [],
      tableHeader: [
          {
            title: "考试批次",
            prop: "planName",
          },
          {
            title: "考点",
            prop: "placeName",
          },
          {
            title: "考试场次",
            prop: "sessionName",
          },
          {
            title: "教室",
            prop: "classNames",
          },
          {
            title:'考试口令',
            type:'buttons',
            btnList:[
              {
                title:'查看',
                click:this.look
              },
              {
                title:'下载',
                click: this.showDialog,
              }
            ]
            
          }
        ],

      pagination: {
        total: 0,
      },

      requestForm: {
        planId: "",
        placeId: "",
        sessionId: "",
        size: 10,
        page: 1,
      },
    };
  },
  watch: {
    "requestForm.planId": "selectPlaceList",
    "requestForm.placeId":'search'
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      getSelectPlanFn({ needAudit: 31 }).then(({ data }) => {
        if (data) {
          this.$set(this.selectList[0], "data", data);
          this.requestForm.planId = data[0].id;
        }
      });
    },
 
    // 查考点/场次
    selectPlaceList() {
      let params = {
        planId: this.requestForm.planId,
      };
      getCurrentSelectPlace(params).then(({ data }) => {
        this.requestForm.placeId = "";
        if (data) {
          let placeList = [{ id: "", name: "全部" }, ...data];
          this.$set(this.selectList[1], "data", placeList);
        } else {
          let placeList = [{ id: "", name: "全部" }];
          this.$set(this.selectList[1], "data", placeList);
        }
      });
      getPlanAllSessionByPlan(params).then(({ data }) => {
        this.requestForm.sessionId = "";
        let sessionList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[2], "data", sessionList);
      });
      this.search();
    },
    // 搜索
    search() {
      let params = { ...this.requestForm };
   
      getPlanPlaceSessionClassFn(params).then((res) => {
        if(res.code == 1){
        this.pagination.total = res.data.total;
        this.tableData = res.data.records;
        }
      });
    },
    // 导出考场门贴
  
 
    changeSize(num) {
      this.requestForm.size = num;
      this.search();
    },
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
    look(row){
      window.localStorage.setItem('lookclass',JSON.stringify(row))
      this.$router.push({
        name:'viewExamcodeLook',
      })
    },
    showDialog(row){
      let params = {
        placeId:row.placeId,
        planId:row.planId, 
        sessionId:row.sessionId
      }
      exportExamOrderexcel(params).then((res)=>{
        window.location.href = res.data.address;
      })
    },
  },
};
</script>

<style lang="less" scoped></style>
